import React, { useState } from 'react';
import { PDFUploader } from './components/PDFUploader';
import { FlipbookViewer } from './components/FlipbookViewer';
export function App() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
  };
  const handleClose = () => {
    setSelectedFile(null);
  };
  return <div className="w-full min-h-screen" data-id="element-0">
      {!selectedFile ? <PDFUploader onFileSelect={handleFileSelect} data-id="element-1" /> : <FlipbookViewer file={selectedFile} onClose={handleClose} data-id="element-2" />}
    </div>;
}